import { render, staticRenderFns } from "./FlightDetailsHeader.vue?vue&type=template&id=504406f8&"
import script from "./FlightDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./FlightDetailsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports